import {
  TIntegrationOffice,
  TIntegrationOfficeRelation,
  TIntegrationOfficeRelationData,
} from "types/integration-sync-office.type";
import {
  TJupixOfficeApiData,
  TJupixOfficeRelationApiData,
} from "types/jupix.type";
import { TJupixConfig } from "types/account-integration.type";

export const isJupixConnected = (config?: TJupixConfig): boolean =>
  !!config?.tokenExpiresAt &&
  new Date(config.tokenExpiresAt).getTime() > Date.now();

export const jupixOfficeDataToIntegrationOfficeDataMapper = (
  jupixOffices: TJupixOfficeApiData[]
): TIntegrationOffice[] => {
  return jupixOffices.map(jupixOffice => {
    return {
      id: String(jupixOffice.jupixId),
      name: jupixOffice.jupixName,
    };
  });
};

export const mapJupixOfficeRelationsToIntegrationOfficeRelations = (
  jupixOfficeRelations: TJupixOfficeRelationApiData[]
): TIntegrationOfficeRelation[] => {
  return jupixOfficeRelations.map(jupixOfficeRelation => {
    return {
      id: jupixOfficeRelation.id,
      officeId: jupixOfficeRelation.officeId,
      branchId: String(jupixOfficeRelation.jupixOfficeId),
    };
  });
};

export const mapIntegrationOfficeRelationsToJupixOfficeRelations = (
  relations: TIntegrationOfficeRelationData[]
) => {
  return relations.map(relation => {
    return {
      officeId: relation.officeId,
      jupixOfficeId:
        relation.branchId === null ? null : Number(relation.branchId),
    };
  });
};
